import { useContext } from 'react';
import { assertContext } from '@gopeerproject/ui-kit';
import { SelectedParticipantContext } from '../MediaContext';
export const useSelectedParticipant = () => {
    const [selectedParticipant, setSelectedParticipant] = assertContext(useContext(SelectedParticipantContext), 'useSelectedParticipant', 'SelectedParticipantProvider');
    return [selectedParticipant, setSelectedParticipant];
};
//# sourceMappingURL=useSelectedParticipant.js.map